import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./index.module.scss";

export type Props = {
  src?: string;
  width?: number;
  height?: number;
  path?: string;
};

const Logo2: React.FC<Props> = (props) => {
  const { src = "/images/logo-promptdee-trans-blue.svg", width = 296, height = 296, path } = props;
  // const navigate = useNavigate();

  return (
    <>
      {path ? (
        <Link to={path}>
          <div className={styles.wrapper} style={{ width, height }}>
            <img className={styles.img} src={src} />
          </div>
        </Link>
      ) : (
        <div className={styles.wrapper} style={{ width, height }}>
          <img className={styles.img} src={src} />
        </div>
      )}
    </>
  );
};
export default Logo2;
